import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MenuService, MenuItem, CondicionesResponse, IndicatorResponse } from '../../services/menu.service';
import { SseService } from 'src/app/services/SseService';
import { CookieService } from 'ngx-cookie-service';

interface Condition {
  label: string;
  action: string;
  type: string;
  editable?: boolean;
  idindicador?: number;
}

@Component({
  selector: 'app-condiciones',
  templateUrl: './condiciones.component.html',
  styleUrls: ['./condiciones.component.scss']
})
export class CondicionesComponent implements OnInit {
  selectedType: 'INDICADORES' | 'RATIOS' = 'INDICADORES';
  displayedColumns: string[] = ['index', 'label'];
  displayedColumnsindi: string[] = ['index', 'label', 'action'];
  token: string = '';

  indicadoresDataSource = new MatTableDataSource<Condition>([]);
  condicionesDataSource = new MatTableDataSource<Condition>([]);
  menuData: MenuItem[] = [];
  loading = false;
  loadingCondiciones = false;
  error: string | null = null;
  selectedRow: Condition | null = null;

  indicadoresFilterValue: string = '';
  condicionesFilterValue: string = '';

  constructor(private cookieService: CookieService, private menuService: MenuService, private apisseservice: SseService ) {}

  ngOnInit() {
        this.token = this.cookieService.get('auth_token');

    this.fetchMenuData();
    this.setupFilters();
  }

  private fetchMenuData(): void {
    this.loading = true;
    this.error = null;

    /**this.menuService.getMenuData().subscribe({
      next: (data: MenuItem[]) => {
        this.menuData = data;
        this.loadConditions();
        this.loading = false;
      },
      error: (error: Error) => {
        console.error('Error fetching menu data:', error);
        this.error = 'Error cargando los datos';
        this.loading = false;
      }
    });**/
     let auth_token = this.cookieService.get('auth_token');
    this.apisseservice.apiPostNew('menu', {}, auth_token).subscribe({
      next: (data: MenuItem[]) => {
        this.menuData = data;
        this.loadConditions();
        this.loading = false;
      },
      error: (error: any) => {
        console.error('Error fetching menu data:', error);
        this.error = 'Error cargando los datos del menú';
        this.loading = false;
      }
    });

  }

  private setupFilters() {
    // Filter for indicadores table
    this.indicadoresDataSource.filterPredicate = (data: Condition, filter: string) => {
      return data.label.toLowerCase().includes(filter.toLowerCase());
    };

    // Filter for condiciones table
    this.condicionesDataSource.filterPredicate = (data: Condition, filter: string) => {
      return data.label.toLowerCase().includes(filter.toLowerCase());
    };
  }

  applyIndicadoresFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.indicadoresDataSource.filter = filterValue.trim().toLowerCase();
  }

  applyCondicionesFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.condicionesDataSource.filter = filterValue.trim().toLowerCase();
  }

  onSelectIndicador(row: Condition): void {
    this.selectedRow = row;
    this.loadingCondiciones = true;
    
     this.apisseservice.apiPostNew('condicionesporindicador', { indicador: row.label }, this.token).subscribe({
      next: (response: CondicionesResponse) => {
        this.condicionesDataSource.data = response.condiciones.map(condicion => ({
          label: condicion.indicador,
          action: 'true',
          type: this.selectedType,
            editable: condicion.editable || false,
            idindicador: condicion.idindicador
        }));
        this.loadingCondiciones = false;
      },
      error: (error: Error) => {
        console.error('Error fetching condiciones:', error);
        this.error = 'Error cargando las condiciones del indicador';
        this.loadingCondiciones = false;
      }
    });
  }

  onTypeChange(value: 'INDICADORES' | 'RATIOS'): void {
    this.selectedType = value;
    this.loadConditions();
    this.selectedRow = null;
    this.condicionesDataSource.data = [];
  }

  private loadConditions(): void {
    if (!this.menuData.length) return;

    let tecnico = true;
    if (this.selectedType === 'RATIOS') {
      tecnico = false;
    }

    this.loading = true;
    this.menuService.getIndicadoresPorTecnico(tecnico).subscribe({
      next: (indicators: IndicatorResponse[]) => {
        const conditions: Condition[] = indicators.map(item => ({
          label: item.indicador,
          action: item.contador.toString(),
          type: this.selectedType
        }));
        
        this.indicadoresDataSource.data = conditions;
        this.loading = false;
      },
      error: (error: Error) => {
        console.error('Error loading indicators:', error);
        this.error = 'Error cargando los indicadores';
        this.loading = false;
      }
    });
  }
}
